<script>
import {NavLinksHelper} from "@/helpers/NavLinksHelper";

export default {
    name: "SideNavItem",
    props: {
        icon: {
            type: String,
            default: ""
        },
        text: String,
        page: {
            type: String,
            default: ""
        },
    },
    emits: ["navigate", "click"],
    computed: {
        isSelected() {
            if (!this.page) return false;
            return NavLinksHelper.findByPath(this.$route.path)?.page === this.page;
        },
        compIcon(){
            if (this.icon){
                return require(`../../assets/icons/${this.icon}`);
            }
            else {
                return "";
            }
        }
    },
    methods: {
        onNavClick(e) {
            if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {
                return;
            }
            this.$emit("navigate", e);
        }
    }
}
</script>

<template>
    <router-link
        v-if="page"
        :to="page"
        class="side-nav-item"
        :class="{ selected: isSelected }"
        active-class="selected"
        @click="onNavClick"
    >
        <inline-svg class="icon" :src="compIcon"></inline-svg>
        <p class="text">{{text}}</p>
    </router-link>
    <div v-else class="side-nav-item" @click="$emit('click', $event)">
        <inline-svg class="icon" :src="compIcon"></inline-svg>
        <p class="text">{{text}}</p>
    </div>
</template>

<style scoped>
.side-nav-item {
    text-decoration: none;
    color: inherit;
}
</style>
